import ApexProvider from "./ApexProvider";
import FetchSettings from "../../interfaces/FetchSettings";
import {
  VMGetDiscussionBugRes,
  VMGetDefaultBugDbAccountRes,
  VMGetBugDbAccountRes,
} from "../../types/VirtualMachineApi";

export default class ApexBugDbProvider extends ApexProvider {
  public async getDiscussionBug(
    discussionId: number
  ): Promise<VMGetDiscussionBugRes> {
    const settings: FetchSettings = {
      method: "GET",
    };
    try {
      const response: VMGetDiscussionBugRes = await this.request(
        this.baseUrl + "BugDb/postsBugs/" + discussionId,
        settings
      );
      return response;
    } catch (error) {
      return {
        found: false,
      };
    }
  }

  public async getDefaultBugDbAccount(
    userEmail: string
  ): Promise<VMGetDefaultBugDbAccountRes> {
    const settings: FetchSettings = {
      method: "GET",
    };
    try {
      const response: VMGetDefaultBugDbAccountRes = await this.request(
        this.baseUrl + "BugDb/usersLocal/" + encodeURIComponent(userEmail),
        settings
      );
      console.log("getDefaultBugDbAccount response", response);
      return response;
    } catch (error) {
      return {
        found: false,
      };
    }
  }

  public async getBugDbAccount(
    bugDbAccount: string
  ): Promise<VMGetBugDbAccountRes> {
    const settings: FetchSettings = {
      method: "GET",
    };
    try {
      const response: VMGetBugDbAccountRes = await this.request(
        this.baseUrl + "BugDb/usersRemote/" + bugDbAccount,
        settings
      );
      console.log("getBugDbAccount response", response);
      return response;
    } catch (error) {
      return {
        found: false,
      };
    }
  }

  // public async getJiraProjects(
  //   categoryId: number
  // ): Promise<Array<VMJiraProject>> {
  //   const settings: FetchSettings = {
  //     method: "GET",
  //   };
  //   try {
  //     const response: Array<VMJiraProject> = await this.request(
  //       this.baseUrl + "jiratask/jiralist/" + categoryId,
  //       settings
  //     );
  //     console.log("Get JIRA projects response", response);
  //     return response;
  //   } catch (error) {
  //     return [];
  //   }
  // }

  // public async createEpic(epic: VMEpic): Promise<VMCreateEpicRes> {
  //   console.log("Creating JIRA Epic...");
  //   const formData = new FormData();
  //   formData.append("subject", epic.subject);
  //   formData.append("forumHash", epic.forumHash);
  //   formData.append("postHash", epic.postHash);
  //   formData.append("userEmail", epic.userEmail);
  //   formData.append("fields[0][name]", "");
  //   formData.append("fields[0][value]", epic.body);
  //   formData.append("projectId", epic.projectId);
  //   const settings: FetchSettings = {
  //     method: "POST",
  //     body: formData,
  //   };
  //   try {
  //     const response: VMCreateEpicRes = await this.request(
  //       this.baseUrl + "jiratask/create",
  //       settings
  //     );
  //     console.log("JIRA Epic created response", response);
  //     return response;
  //   } catch (error) {
  //     return {
  //       success: false,
  //       msg: "Server didn't respond. Please contact an administrator.",
  //     };
  //   }
  // }
}
